{
	"cancelStyleCreationMessage": "Are you sure you want to cancel the style creation?",
	"cancelStyleCreationTitle": "Cancel Style Creation",
	"failedGenerateTitle": "Failed to Generate AI Style",
	"generatingMessage": "This may take a few moments. Please do not close the app.",
	"generatingTitle": "Generating AI Style",
	"missingEditMetadataTitle": "Missing Edit Metadata",
	"tryAgainLater": "Please try again later."
}
